var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseCross(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.73528 2.73533C1.22574 4.24486 1.22545 6.69616 2.73491 8.20561L22.7943 28.265C24.3038 29.7745 26.7551 29.7742 28.2646 28.2647C29.7742 26.7551 29.7744 24.3038 28.265 22.7944L8.20556 2.73496C6.69611 1.2255 4.24481 1.22579 2.73528 2.73533ZM4.55856 4.55861C5.06186 4.05531 5.87903 4.05553 6.38201 4.55851L26.4414 24.6179C26.9444 25.1209 26.9446 25.9381 26.4413 26.4414C25.938 26.9447 25.1209 26.9445 24.6179 26.4415L4.55846 6.38206C4.05548 5.87908 4.05526 5.06191 4.55856 4.55861Z",
    fill: "#3B2D41"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.8517 17.3227L4.5573 24.6171C4.05441 25.1207 4.05441 25.9375 4.5573 26.441C5.06082 26.9439 5.87767 26.9439 6.3812 26.441L10.7189 22.1033C11.2218 21.5998 12.0393 21.5998 12.5422 22.1033C13.0457 22.6062 13.0457 23.4237 12.5422 23.9266L8.20448 28.2643C6.69518 29.7742 4.24396 29.7742 2.73402 28.2643C1.22408 26.7544 1.22408 24.3031 2.73402 22.7938L10.9401 14.5878C11.4436 14.0843 12.2598 14.0843 12.7633 14.5878L16.4105 18.235C16.9141 18.7379 16.9141 19.5554 16.4105 20.0583C15.9076 20.5618 15.0901 20.5618 14.5872 20.0583L11.8517 17.3227ZM14.5872 10.9406C14.0837 11.4441 14.0837 12.2604 14.5872 12.7639L18.2344 16.4111C18.738 16.9146 19.5542 16.9146 20.0577 16.4111L28.2638 8.20503C29.7737 6.69573 29.7737 4.24451 28.2638 2.73457C26.7538 1.22463 24.3026 1.22463 22.7933 2.73457L14.5872 10.9406ZM19.1461 13.6762L26.4405 6.38175C26.9434 5.87822 26.9434 5.06137 26.4405 4.55784C25.937 4.05496 25.1201 4.05496 24.6166 4.55784L17.3222 11.8523L19.1461 13.6762Z",
    fill: "#3B2D41"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseCross);
export default __webpack_public_path__ + "static/media/close_cross.8582a0edf284518815ef291163e5072d.svg";
export { ForwardRef as ReactComponent };